import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button, Select, MenuItem, Grid, TextField, FormControl, InputLabel } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import CellImage from "src/components/common/CellImage";
import { asyncRequest } from "src/services/network";
import MerchantInfo from "src/components/common/MerchantInfo";
import { useSelector } from "react-redux";
import ProductEdit from "./components/ProductEdit";
import { getLowestPrice } from "src/utils/util";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "cover", label: "封面", alignRight: false },
  { id: "name", label: "商品名称", alignRight: false },
  { id: "wholesalePrice", label: "批发价", alignRight: false },
  { id: "price", label: "售价", alignRight: false },
  // { id: "buyCount", label: "销量", alignRight: false },
  // { id: "stock", label: "库存", alignRight: false },
  // { id: "isShow", label: "上/下架", alignRight: false },
  { id: "isImported", label: "已导入", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  { title: "导入", icon: iconEdit2 },
  // { title: "删除", icon: iconEdit2 },
];

export default function ProductZy() {
  const { sectionMap, supplierMap, storeSections } = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});

  const [productMap, setProductMap] = useState({});

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/zy/product/list",
      data: filter,
    });

    setItems(
      data.map((d) => {
        const extra = {};
        if (d.specType == 1) {
          const priceItem = getLowestPrice(d.priceList);
        }
        return {
          ...d,
          ...extra,
        };
      })
    );
    setTotal(count);

    getImported(data.map(d => d.id))
  }

  async function getImported(sourceIds) {
    const { data, count } = await asyncRequest({
      path: "/store/product/getBySourceIds",
      data: {
        sourceId: sourceIds
      },
    });

    const map = {...productMap};
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      map[element.sourceId] = true;
    }

    setProductMap(map)

  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleFilterChange = (ki, val) => {
    setFilter({
      ...filter,
      [ki]: val,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "导入") {
      // navigate(`/product/edit/${row.id}`, { state: row });
      setAction("add");
      setTargetItem({
        price: row.price,
        cost: row.wholesalePrice,
        name: row.goodsName,
        images: row.goodsGalleryList.join(','),
        cover: row.thumbnail,
        unit: row.goodsUnit,
        detail: row.intro,
        sourceId: row.id,
        skuId: row.skus[0].id,
        from: 'zy'
      });
    }
  };

  const isUserNotFound = items.length === 0;

  return (
    <Page title="中赢产品列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            中赢产品列表
          </Typography>

          {/* <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setTargetItem({});
              setAction("add");
            }}
          >
            添加产品
          </Button> */}
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
            <Grid container gap={2}>
              <Grid item>
                <TextField
                  style={{ width: 200 }}
                  label="名称"
                  placeholder="名称"
                  autoComplete="off"
                  id="name"
                  size="small"
                  value={filter.name}
                  onChange={(e) => {
                    handleFilterChange("name", e.target.value);
                  }}
                />
              </Grid>

              {/* <Grid item>
                <FormControl size="small">
                  <InputLabel>状态</InputLabel>
                  <Select
                    label="状态"
                    value={PAYMENT_STATUS_MAP[filter.status]}
                    onChange={(e) => {
                      handleFilterChange("status", e.target.value);
                    }}
                    style={{ width: 250 }}
                  >
                    {statuses.map((status, idx) => (
                      <MenuItem key={idx} value={status} name={status}>
                        {PAYMENT_STATUS_MAP[status]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    handleFilterChange("createdAt", val);
                  }}
                />
              </Grid> */}
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, goodsName, thumbnail, wholesalePrice, createTime, price } = row;
                    const isItemSelected = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, id)}
                            />
                          </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">
                          <CellImage src={thumbnail} />
                        </TableCell>
                        <TableCell align="left">
                          {goodsName}
                        </TableCell>
                        <TableCell align="left">{wholesalePrice}</TableCell>
                        <TableCell align="left">{price}</TableCell>
                        <TableCell align="left">{productMap[id] ? '是' : null}</TableCell>

                        {/* <TableCell align="left">{order}</TableCell> */}
                        <TableCell align="left">{moment(createTime).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {(action == "add" || action == "edit") && (
        <ProductEdit
          open
          action={action}
          item={targetItem}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}
    </Page>
  );
}
